import styled from 'styled-components';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';

import { AddIcon, SubIcon } from '../../../../Common/SvgIcon/CommonSvgIcons';
import React, { useState, useRef, useEffect } from 'react';

const Card = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  & span {
    cursor: pointer;
  }
`;

const InputWrapper = styled.div`
  border-radius: 20px;
  background: #fff;

  width: 368.3px;
  height: ${(props) => props?.isHomePage ? '23px' : '44.467px'};

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const StyledCheckIcon = styled(CheckIcon)`
  width: 20px;
  height: 20px;
  border: 1px solid rgba(152, 152, 152, 0.24);
  margin: 0 10px;
  border-radius: 50%;
  color: #fff;
  background: var(--Headlines,rgba(42,136,107,1));

  ${({ active }) => active === 'false' && 'background: #fff'}
`;

const KeyWordType = styled.div`
  position: relative;
  height: 100%;
  width: ${(props) => props?.isHomePage ? '12%' : '24%'};

  display: flex;
  align-items: center;
  gap: 15px;
  border-radius: 27.067px;
  background: #000;
  color: #fff;
  padding: 0 22px;
  height: 100%;
  font-size:${(props) => props?.isHomePage ? '10px' : '15px'};
  font-family:inherit;
  font-weight: 600;

  & > svg {
    position: absolute;
    right: 0px;
    width:${(props) => props?.isHomePage ? '10px' : '1em'};
    height:${(props) => props?.isHomePage ? '10px' : '1em'};
  }
`;
const TextArea = styled.input`
  height: 100%;
  outline: none;
  border: none;
  width: 50%;
  padding: 0 15px;

  color: #636363;
  font-size: ${(props) => props?.isHomePage ? '10px' : '16px'};
  font-family: inherit;
  font-weight: 500;

  border-radius: 20px;
  flex: 1;
`;

const KeyWordTypeList = styled.ul`
  position: absolute;

  top: 90%;
  left: 0%;

  background: #fff;
  padding: 10px 0;

  width: 200px;

  box-shadow: 0px 0px 8px rgba(85, 85, 85, 0.25);
  border-radius: 15px;

  font-size: 20px;
  font-weight: 500;

  z-index: 100;

  & > li {
    display: flex;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    border-radius: 15px;

    color: #707070;

    &:hover {
      background-color: rgb(240, 255, 240);
    }
  }
`;

const Input = ({
  inputData: {
    index,
    inputChangeHandler,
    removeNewKeyword,
    addNewKeyword,
    keyword,
    exclude,
    changeKeywordType,
  },
  keywordType,
  isHomePage=false
}) => {
  const [optionTab, setOptionTab] = useState(false);

  const inputRef = useRef(null);
  const selectedOption = keyword.keywordType;

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setOptionTab(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);
  return (
    <Card>
      <InputWrapper isHomePage={isHomePage}>
        <KeyWordType
          onClick={() => !isHomePage && setOptionTab((prev) => !prev)}
          ref={inputRef}
          isHomePage={isHomePage}
        >
          {selectedOption} {!isHomePage  && <KeyboardArrowDownIcon />}
          {optionTab && (
            <KeyWordTypeList>
              {keywordType.map((op) => (
                <li key={op} onClick={() => changeKeywordType(op, index)}>
                  <StyledCheckIcon
                    active={(selectedOption.trim() === op.trim()).toString()}
                  />
                  {op}
                </li>
              ))}
            </KeyWordTypeList>
          )}
        </KeyWordType>
        <TextArea
          onChange={(e) => inputChangeHandler(index, e.target.value)}
          placeholder='Enter keyword... '
          value={
            exclude
              ? keyword?.value?.includes('#')
                ? keyword.value?.length < 2
                  ? keyword?.value
                  : keyword?.value[1] +
                    keyword?.value[0] +
                    keyword?.value.slice(2)
                : keyword?.value
              : keyword.value
          }
          isHomePage={isHomePage}
        />
      </InputWrapper>
      <span onClick={addNewKeyword}>{AddIcon}</span>
      <span onClick={() => removeNewKeyword(index)}>{SubIcon}</span>
    </Card>
  );
};

export default Input;
